<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('inventory movements')"
      :columns="columns"
      :column_search="true"
      resource_url="/inventory/movement/datatables"
      page_length="25"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <inventory-movement-modal
      ref="inventory_movement_modal"
      @success="refresh"
    />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import InventoryMovementModal from "./inventory_movement_modal/Index.vue";

export default {
  name: "InventoryMovementDatatable",
  components: { GenericTable, InventoryMovementModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "12%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date) || "";
          },
        },
        {
          title: v.$t("warehouse"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.warehouse ? row.warehouse.name || "" : "";
          },
        },
        {
          title: v.$t("movement type"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.movement_type.name || "";
          },
        },
        {
          title: v.$t("quantity"),
          name: "quantity",
          // width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.quantity || "";
          },
        },
        {
          title: v.$t("product"),
          searchable: false,
          // width: "40%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.product.name || "";
          },
        },
        // {
        //   title: v.$t("comment"),
        //   name: "comment",
        //   width: "15%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.comment || "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   // name: "name",
        //   searchable: false,
        //   width: "35%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return JSON.stringify(row, null, 2) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.provider_modal.show_modal(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete movement?"),
                    v,
                    () => {
                      del("/inventory/movement", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.inventory_movement_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
